module.exports = __webpack_public_path__ + "img/11.28e01015.jpg";